declare namespace AppInsights {}

export { AppInsightsErrorHandler } from './appinsights/errorhandler';
export { AppInsightsModule } from './appinsights/appinsights.module';
export { AppInsightsService } from './appinsights/appinsights.service';
export { SeverityLevel } from './appinsights/severitylevel';
export { Config } from './appinsights/config.interface';
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
